import type { ReactNode } from 'react';

interface SolarEcommPageLayoutProps {
  children: ReactNode;
}

export default function SolarEcommPageLayout({
  children,
}: SolarEcommPageLayoutProps) {
  return (
    <div>
      <header>Solar Ecomm</header>
      <main>{children}</main>
    </div>
  );
}
